import { element, showMessage } from './publicUi.js';

const lines = value => value.split(/\r?\n/).map(v => v.trim()).filter(Boolean);
const collections = {
  toolGroups: { title: 'Группы инструментов', add: 'Добавить группу', max: 20, fields: [['name', 'Название группы', 100], ['nameEn', 'Название группы на английском (необязательно)', 100, 'optional'],
    ['tools', 'Инструменты — по одному на строке', 8040, 'lines'], ['toolsEn', 'Инструменты на английском — по одному на строке', 8040, 'lines']] },
  featureCards: { title: 'Карточки разделов', add: 'Добавить карточку', max: 3, fields: [['route', 'Раздел', 0, 'select'], ['title', 'Название карточки', 100],
    ['titleEn', 'Название карточки на английском (необязательно)', 100, 'optional'], ['subtitle', 'Подпись карточки', 1000, 'optional'],
    ['subtitleEn', 'Подпись карточки на английском (необязательно)', 1000, 'optional']] },
  publicLinks: { title: 'Публичные ссылки', add: 'Добавить ссылку', max: 20, fields: [['label', 'Подпись ссылки', 100],
    ['labelEn', 'Подпись ссылки на английском (необязательно)', 100, 'optional'], ['href', 'Адрес ссылки', 2000]] },
};

export class ProfileEditor {
  constructor({ profile, save, denied, reload }) { Object.assign(this, { profile, save, denied, reload }); this.fields = {}; this.groups = {}; this.version = profile.version; }
  field(parent, name, label, max, kind, value = '') {
    const caption = element('label', 'auth-form-label', label);
    const control = element(kind === 'select' ? 'select' : ['lines', 'textarea'].includes(kind) ? 'textarea' : 'input', 'auth-input');
    control.name = name;
    if (kind === 'select') {
      for (const [key, title] of [['blog', 'Блог'], ['files', 'Файлы'], ['gallery', 'Галерея']]) {
        const option = element('option', '', title); option.value = key; option.selected = key === (value || 'blog'); control.append(option);
      }
    } else {
      control.maxLength = max; control.value = Array.isArray(value) ? value.join('\n') : value;
      if (control.tagName === 'TEXTAREA') control.rows = 3;
    }
    control.required = !name.endsWith('En') && !['optional', 'textarea', 'lines'].includes(kind);
    control.addEventListener('invalid', () => { const section = control.closest('details'); if (section) section.setAttribute('open', ''); });
    caption.append(control); parent.append(caption); return control;
  }
  render() {
    this.form = element('form', 'spec-box profile-editor');
    this.heading = element('h2', 'spec-title', `Публичный профиль · версия ${this.version}`); this.form.append(this.heading);
    this.form.append(element('p', 'profile-text', 'Изменения публикуются после сохранения. Переход в другой раздел или перезагрузка сбрасывает несохранённые правки.'));
    for (const [name, label, max, kind] of [['siteName', 'Название сайта', 100], ['description', 'Описание сайта', 1000, 'textarea'],
      ['whoamiText', 'Текст whoami', 1000, 'textarea']]) this.fields[name] = this.field(this.form, name, label, max, kind, this.profile[name]);
    const advanced = element('details', 'profile-editor-collection');
    advanced.append(element('summary', 'profile-editor-summary', 'Дополнительные тексты'));
    for (const [name, label, max, kind] of [
      ['missionText', 'Миссия', 5000, 'textarea'],
      ['bio', 'Биография', 5000, 'textarea'], ['specializations', 'Специализации — по одной на строке', 8040, 'lines'],
    ]) this.fields[name] = this.field(advanced, name, label, max, kind, this.profile[name]);
    this.form.append(advanced);
    const english = element('details', 'profile-editor-collection');
    english.append(element('summary', 'profile-editor-summary', 'Английская версия профиля (необязательно)'),
      element('p', 'profile-text', 'Для перевода списков укажите столько же строк, сколько в русском списке. Пустое поле показывает русский текст.'));
    for (const [name, label, max, kind] of [
      ['descriptionEn', 'Описание сайта на английском', 1000, 'textarea'],
      ['whoamiTextEn', 'Текст whoami на английском', 1000, 'textarea'],
      ['missionTextEn', 'Миссия на английском', 5000, 'textarea'],
      ['bioEn', 'Биография на английском', 5000, 'textarea'],
      ['specializationsEn', 'Специализации на английском — по одной на строке', 8040, 'lines'],
    ]) this.fields[name] = this.field(english, name, label, max, kind, this.profile[name]);
    this.form.append(english);
    for (const [name, spec] of Object.entries(collections)) {
      const section = element('details', 'profile-editor-collection');
      const summary = element('summary', 'profile-editor-summary'); section.append(summary);
      const rows = element('div', 'profile-editor-rows'), add = element('button', 'filter-btn', spec.add); add.type = 'button';
      this.groups[name] = { rows, add, summary, entries: [] }; section.append(rows, add); this.form.append(section);
      add.addEventListener('click', () => { if (!this.busy && !this.disposed) this.addRow(name); });
      for (const row of this.profile[name]) this.addRow(name, row);
      this.updateSummary(name);
    }
    this.feedback = element('div'); this.feedback.setAttribute('role', 'status');
    const submit = element('button', 'filter-btn', 'Сохранить профиль');
    const reload = element('button', 'filter-btn', 'Отменить правки и загрузить заново'); reload.type = 'button';
    reload.addEventListener('click', () => { if (!this.busy && !this.disposed) this.reload(); });
    this.form.append(submit, reload, this.feedback);
    this.form.addEventListener('submit', event => { event.preventDefault(); void this.submit(); });
    this.baseline = this.values(); return this.form;
  }
  addRow(name, data = {}) {
    const spec = collections[name], group = this.groups[name]; if (group.entries.length >= spec.max) return;
    const box = element('fieldset', 'profile-editor-row'); box.append(element('legend', '', spec.title));
    const entry = { box, fields: {} };
    for (const [key, label, max, kind] of spec.fields) entry.fields[key] = this.field(box, key, label, max, kind, data[key] ?? '');
    const remove = element('button', 'filter-btn', 'Удалить строку'); remove.type = 'button';
    remove.addEventListener('click', () => {
      if (this.busy || this.disposed) return;
      group.entries = group.entries.filter(item => item !== entry); box.remove(); group.add.disabled = false;
      this.updateSummary(name);
    });
    box.append(remove); group.entries.push(entry); group.rows.append(box); group.add.disabled = group.entries.length >= spec.max;
    this.updateSummary(name);
  }
  updateSummary(name) {
    const group = this.groups[name];
    group.summary.textContent = `${collections[name].title} · ${group.entries.length}`;
  }
  values() {
    const data = Object.fromEntries(Object.entries(this.fields).map(([key, field]) => [key, ['specializations', 'specializationsEn'].includes(key) ? lines(field.value) : field.value]));
    for (const [name, group] of Object.entries(this.groups)) data[name] = group.entries.map(entry => Object.fromEntries(Object.entries(entry.fields).map(([key, field]) => [key, ['tools', 'toolsEn'].includes(key) ? lines(field.value) : field.value])));
    return data;
  }
  async submit() {
    if (this.busy || this.disposed) return;
    const data = this.values();
    if ([data.specializations, data.specializationsEn, ...data.toolGroups.flatMap(group => [group.tools, group.toolsEn])].some(list => list.length > 40 || list.some(value => value.length > 200))) { showMessage(this.feedback, 'Допустимо до 40 строк по 200 символов в специализациях и каждой группе инструментов.'); return; }
    if ((data.specializationsEn.length && data.specializationsEn.length !== data.specializations.length)
      || data.toolGroups.some(group => group.toolsEn.length && group.toolsEn.length !== group.tools.length)) {
      showMessage(this.feedback, 'Количество английских строк должно совпадать с русским списком.'); return;
    }
    if (new Set(data.featureCards.map(card => card.route)).size !== data.featureCards.length) { showMessage(this.feedback, 'Каждый раздел можно добавить в карточки только один раз.'); return; }
    for (const link of data.publicLinks) {
      try { const url = new URL(link.href); if (!['http:', 'https:', 'mailto:'].includes(url.protocol) || url.username || url.password || /[\x00-\x20]/.test(link.href)) throw new Error(); }
      catch { showMessage(this.feedback, 'Укажите ссылку http, https или mailto без пробелов и учётных данных.'); return; }
    }
    const changed = Object.fromEntries(Object.entries(data).filter(([key, value]) => JSON.stringify(value) !== JSON.stringify(this.baseline[key])));
    if (!Object.keys(changed).length) { showMessage(this.feedback, 'Нет изменений для сохранения.'); return; }
    this.busy = true; const controls = [...this.form.querySelectorAll('input,textarea,select,button')]; controls.forEach(c => { c.disabled = true; });
    showMessage(this.feedback, 'Сохранение…');
    try {
      const result = await this.save({ ...changed, version: this.version });
      if (this.disposed) return;
      this.version = result.version; this.baseline = data; this.heading.textContent = `Публичный профиль · версия ${this.version}`;
      showMessage(this.feedback, 'Профиль сохранён.');
    } catch (error) {
      if (!this.disposed) { if ([401, 403].includes(error.status)) this.denied(error); else showMessage(this.feedback, error.message); }
    } finally {
      this.busy = false; controls.forEach(c => { c.disabled = false; });
      for (const [name, group] of Object.entries(this.groups)) group.add.disabled = group.entries.length >= collections[name].max;
    }
  }
  dispose() { this.disposed = true; }
}
